export const fileToDataString = (file: File) => {
    return new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onerror = (error) => reject(error);
        reader.onload = () => resolve(reader.result as string);
    });
};

export const getImgSrc = (profilePictureSrc: string | undefined) => {
    if (!profilePictureSrc) return undefined;
    return `/uploads/${profilePictureSrc}`;
}

/** Original image filename from profile (cropped) filename: "a-b.jpg" → "a-b-original.jpg" */
export const getOriginalProfilePictureSrc = (profilePictureSrc: string | undefined) => {
    if (!profilePictureSrc) return undefined
    const lastDot = profilePictureSrc.lastIndexOf(".")
    if (lastDot === -1) return `${profilePictureSrc}-original`
    return profilePictureSrc.slice(0, lastDot) + "-original" + profilePictureSrc.slice(lastDot)
}
